<template>
  <div class="flex flex-col items-center justify-center h-screen bg-black px-4">
    <p class="text-tp-yellow text-3xl font-bold text-center mb-6">¡Vaya, algo salió mal!</p>
    <div class="space-y-2">
      <p class="text-tp-yellow text-xl text-center">
        No hemos podido procesar tu pago.
      </p>
      <p class="text-tp-yellow text-lg text-center mb-8 max-w-xl">
        Vuelve a escanear el QR e inténtalo de nuevo.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentError'
}
</script>
  